<template>
  <div class="container f-rte" style="margin-top: 20px">
    <Block title="Source" v-if="metadata['source']">
      <div v-html="metadata['source']" />
    </Block>
    <Block title="Number of observations" v-if="metadata['observations']">
      <div v-html="metadata['observations']" />
    </Block>
    <Block title="Methodology" v-if="metadata['methodology']">
      <div v-html="metadata['methodology']" />
    </Block>
    <Block title="Indicators notes" v-if="metadata['indicators']">
      <div
        v-for="(indicator, i) of Object.keys(metadata['indicators'])"
        :key="`indicator-${i}`"
      >
        <strong>
          {{ indicator }}
        </strong>
        <div v-html="metadata['indicators'][indicator]" />
        <br />
      </div>
    </Block>
    <Block title="Country notes" v-if="metadata['countries']">
      <div v-html="metadata['countries']" />
    </Block>
  </div>
</template>

<script>
import { Block } from "@international-energy-agency/vue-ui";

import { metadataNotesData } from "./data/data";

export default {
  name: "MetaDataView",
  components: {
    Block,
  },
  props: {
    topic: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      metadataNotesData,
    };
  },
  computed: {
    metadata() {
      return metadataNotesData && metadataNotesData[this.topic]
        ? metadataNotesData[this.topic]
        : null;
    },
  },
};
</script>